<template lang="html">
    <!-- modal basics, with header, color & actions  -->
    <v-dialog v-model="isOpen" :max-width="width" :fullscreen="fullscreen" @keydown.enter="warning ? close() : disableEnter ? '' : validate()" @keydown.esc="close" :persistent="true">
        <v-card>
            <v-card-title :class="{ 'warning' : warning }" v-if="title != null">
                <h2>
                    <v-icon v-if="warning">warning</v-icon>
                    <v-icon v-if="!warning && icon">{{ icon }}</v-icon>
                    <span>{{ title }}</span>
                </h2>
                <v-btn small icon @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text :class="card_text_class">
                <template v-if="currentView">
                    <component :is="currentView" :params="params" ref="currentView"></component>
                </template>
            </v-card-text>

            <v-card-actions v-if="currentView != null && actions === true">
                <v-btn round small flat :color="warning ? 'warning' : 'primary'" v-if="cancel_button" @click.native="close">Annuler</v-btn>
                <v-btn round depressed small :color="warning ? 'warning' : 'primary'" @click.native="validate()" :loading="loading" v-if="valid_button" >{{valid_label}}</v-btn>
                <v-btn round depressed small :color="warning ? 'warning' : 'primary'" @click.native="next_step()" :loading="loading" v-if="next_button" >Suivant</v-btn>
                <div v-else>

                </div>
                <v-btn round depressed small color="primary" v-if="more_action" @click.native="validate_add(false, currentView)" :loading="loading">{{more_action}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() {
            return {
                isOpen:         false,
                currentView:    null,
                more_action:    null,
                params:         {},
                title:          null,
                icon:           null,
                width:          null,
                warning:        false,
                loading:        false,
                actions:        true,
                next_button:    false,
                valid_button:   true,
                valid_label:    "Valider",
                cancel_button:  true,
                fullscreen:     false,
                card_text_class: '',
                disableEnter: false
            }
        },

        methods: {
            close() {
                // on click validate, call tha close action of the component given
                this.$refs.currentView.onClose()
            },

            validate() {
                // on click validate, call tha validate action of the component given
                this.loading = true

                if(!this.$refs.currentView.onValidate()) {
                    // this.loading = false
                }
            },
            next_step() {
                // on click validate, call tha validate action of the component given
                this.loading = true

                if(!this.$refs.currentView.onNextStep()) {
                    // this.loading = false
                }
            }

        },

        created() {
            // on open modal, initate data = get the title, the icon ... from the component given
            this.$eventHub.$on('open-modal', (component, params = {}) => {
                this.isOpen         = true
                this.currentView    = component
                this.params         = params

                this.title          = this.currentView.data().title         || null
                this.icon           = this.currentView.data().icon          || null
                this.width          = this.currentView.data().width         || '750px'
                this.fullscreen     = this.currentView.data().fullscreen    || false
                this.warning        = this.currentView.data().warning       || false
                this.more_action    = this.currentView.data().more_action   || null
                this.actions        = this.currentView.data().actions       || true
                this.next_button    = this.currentView.data().next_button   || false;
                this.cancel_button  = this.currentView.data().cancel_button=== false ?  false : true;
                this.valid_button   = this.currentView.data().valid_button === false ?  false : true;
                this.valid_label   = this.currentView.data().valid_label ? this.currentView.data().valid_label : "Valider";
                this.card_text_class   = this.currentView.data().card_text_class || 'small-modal-text';
                this.disableEnter   = this.currentView.data().disableEnter  || false


            })

            // on close reinit
            this.$eventHub.$on('close-modal', () => {
                this.loading        = false
                this.isOpen         = false

                setTimeout(() => { this.currentView = null }, 500)
            })

            // to hide actions of the modal
            this.$eventHub.$on('hide-modal-actions', () => {
                this.actions = false
            })

            // to show actions of the modal
            this.$eventHub.$on('show-modal-actions', () => {
                this.actions = true
            })
            // set the next button (for the convert modal)
            this.$eventHub.$on('set-next-button', params => {
                this.next_button = params
                this.loading = false
            })
            // show the validation button (convert modal)
            this.$eventHub.$on('set-valid-button', params => {
                this.valid_button = params
            })
            // stop loading
            this.$eventHub.$on('stop_loading', () => {
                this.loading = false
            })
        }
    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'

    .dialog {
        font-family: 'Muli', sans-serif
        letter-spacing: -0.4px
        .card {
            .card__title {
                justify-content: space-between
                padding: 1.5rem 2rem
                background: $primary-color

                h2 {
                    display: flex
                    align-items: center
                    margin: 0
                    color: #fff
                    font-size: 1.8rem
                    font-weight: 500

                    .icon {
                        margin: 0 1.5rem 0 0
                        font-size: 3rem
                        color: #fff !important
                    }
                }

                button {
                    margin: 0

                    .icon {
                        font-size: 2rem
                        color: #fff
                    }
                }
            }

            .card__text.small-modal-text {
                padding: 3rem 2rem
            }

            .card__text.fullscreen-modal-text {
                padding: 0
            }

            .card__actions {
                display: flex;
                justify-content: flex-end;
                padding: 1.5rem 2rem

                button:last-of-type {
                    margin-right: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/app/Modal.vue